// ============================================================
// Privacy Policy
// Static content page. Required for payment gateway compliance
// and general legitimacy — linked from footer and used for
// Razorpay website verification.
// ============================================================

import React from 'react';

function PrivacyPolicy({ onBack }) {
  return (
    <div className="policy-page">
      <button className="link-button" onClick={onBack}>← Back</button>
      <h1>Privacy Policy</h1>
      <p className="policy-updated">Last updated: July 2026</p>

      <p>CHART Rubric is operated by ASTC (Agentic SmarTalent Consulting), part of the Sarthi Edge ecosystem. This policy explains what information we collect, how we use it, and how we protect it.</p>

      <h2>What we collect</h2>
      <p>When you take the free trial, we ask for your email address solely to send you a one-time verification code. This email is not stored — it is used only to confirm you are a real person, and is discarded immediately after verification.</p>
      <p>When you purchase a CHART Rubric report, we collect your name, email address, and optionally your phone number. This information is stored securely and used only to deliver your report, respond to support requests, and occasionally follow up about CHART Rubric. We do not sell or share this information with third parties.</p>
      <p>We also collect your career stage, industry, and GCC status (whether you're aspiring to join a GCC or already working in one), which are used to tailor your report content. Your actual answers to the assessment questions are stored so we can generate and, if needed, regenerate your report.</p>

      <h2>Payment information</h2>
      <p>All payments are processed securely through Razorpay. We do not store your card, UPI, or banking details on our servers — this information is handled entirely by Razorpay in accordance with their own security standards.</p>

      <h2>How we use your information</h2>
      <ul>
        <li>To generate and deliver your CHART Rubric report</li>
        <li>To send you your report and any related communication via email</li>
        <li>To respond to feedback, questions, or support requests you submit</li>
        <li>To improve CHART Rubric based on aggregated, anonymized patterns — never by sharing your individual responses</li>
      </ul>

      <h2>Data security</h2>
      <p>Your data is stored on secure, industry-standard infrastructure (MongoDB Atlas) with restricted access. We take reasonable technical measures to protect your information from unauthorized access, loss, or misuse.</p>

      <h2>Your rights</h2>
      <p>You can request a copy of the personal data we hold about you, or request that it be deleted, by contacting us at connect@sarthiedge.com.</p>

      <h2>Contact</h2>
      <p>If you have questions about this policy, please write to us at connect@sarthiedge.com.</p>
    </div>
  );
}

export default PrivacyPolicy;
